/**
 * /frontend/src/features/analytics/components/abandonment/AbandonmentBySectionChart.js
 */

import React from 'react';
import ChartContainer from '../shared/ChartContainer';
import HorizontalBarChart from '../charts/HorizontalBarChart';

/**
 * Abandonment count by section.
 * @param {{data:Array<{sectionName:string,abandonmentCount:number}>}} props
 * @returns {JSX.Element}
 */
const AbandonmentBySectionChart = ({ data }) => (
  <ChartContainer title="Abandonment by Section" subtitle="Where customers drop off most">
    <HorizontalBarChart data={data} xKey="sectionName" yKey="abandonmentCount" />
  </ChartContainer>
);

export default AbandonmentBySectionChart;

